import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static telegramRepublished(query) {
        return PostApiBase.telegramRepublished(query).
        then((resp) => {
            return resp.data
        })
    }

    static siteSalesRepublished(query) {
        return PostApiBase.siteSalesRepublished(query).
        then((resp) => {
            return resp.data
        })
    }

    static siteArticlesRepublished(query) {
        return PostApiBase.siteArticlesRepublished(query).
        then((resp) => {
            return resp.data
        })
    }

    static siteNotesRepublished(query) {
        return PostApiBase.siteNotesRepublished(query).
        then((resp) => {
            return resp.data
        })
    }

    static sitePromocodeRepublished(query) {
        return PostApiBase.sitePromocodeRepublished(query).
        then((resp) => {
            return resp.data
        })
    }
}
